<template>
    <footer class="footer">
        <!-- <a href="#">About Cliëntvolgsysteem</a> -->
        <!-- <a href="#">Privacy & Voorwaarden</a> -->
        <!-- <a href="#">Contact Us</a> -->
        <a href="#">&nbsp;</a>
        <a>&copy; {{ new Date().getFullYear() }} {{ $t('footer.copyrights')}}</a>
    </footer>
</template>

<script>
    import Vue from 'vue';
    import Component from 'vue-class-component';

    @Component
    export default class TheFooter extends Vue {
        name = 'the-footer';
    }

    Vue.component('the-footer', TheFooter);
</script>



// WEBPACK FOOTER //
// src/components/general/TheFooter.vue